import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'

import { NotFound } from 'js/core/NotFound'
import AddEditForm from 'js/magazine/AddEdit/AddEditForm'
import { MAGAZINE_EDIT_WRAPPER } from 'js/magazine/AddEdit/Edit/Edit.queries'

const Edit = () => {
    const { t } = useTranslation()
    const { guid } = useParams()

    const { loading, data } = useQuery<any>(MAGAZINE_EDIT_WRAPPER, {
        variables: {
            guid,
        },
    })

    if (loading) {
        return null
    }
    if (!data || !data.entity) {
        return <NotFound />
    }

    const { entity } = data

    return <AddEditForm title={t('entity-magazine.edit')} entity={entity} />
}

export { MAGAZINE_EDIT_WRAPPER }
export default Edit
